import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  EstructuraReporte,
  Container,
  Dropdown,
  Custom
} from '@app/shared';
import { find } from 'rxjs/operators';


@Injectable()
export class ReportsStructureFormService {

  constructor() { }

  /**
   * Retorna el formulario de informacion basica
   *
   * @param {*} options
   * @param {EstructuraReporte} [datValue]
   * @returns {BaseControl<any>[]}
   * @memberof ReportsStructureFormService
   */
  getForm(options: any, datValue?: EstructuraReporte, reportType?: string, template?: any): BaseControl<any>[] {
    let controls: BaseControl<any>[];
    let imageType: any = options.find((x: {key:any, value:string, others: string; }) => x.others == 'imagen');
    let imageCondition: any[] = [];
    if (imageType){
      imageCondition.push ({
        campoDepende: 'cboTipoCampo',
        siEs: 'Igual',
        valor: imageType.key,
        accion: 'Mostrar'
      })
    }
    if (reportType === 'Experto') {
      controls = [
        new Textbox({
          key: 'txtNombre',
          label: 'Título de la columna',
          value: datValue ? datValue.nombre : '',
          order: 1,
          placeholder: 'Ingrese el título de la columna',
          validations: {
            validators: [Validators.required],
          }
        }),
        new Textbox({
          key: 'txtAlias',
          label: 'Alias de la columna',
          value: datValue ? datValue.alias : '',
          order: 2,
          placeholder: 'Ingrese el alias de la columna',
          validations: {
            validators: [Validators.required],
          }
        }),
        new Container({
          class: 'form-row',
          order: 3,
          controls: [
            new Textbox({
              key: 'txtCelda',
              label: 'Celda Inicial:',
              value: datValue ? datValue.celda : '',
              size: 'col-md-6',
              placeholder: 'Ingrese la celda inicial para la columna',
              validations: {
                validators: [Validators.required, Validators.pattern(/^[A-Z ]*$/)],
                messages: {pattern: 'Caracteres incorrectos. Solo puede ingresar letras en mayuscula.'}
              }
            }),
            new Textbox({
              key: 'txtOrden',
              type: 'number',
              label: 'Orden inicial:',
              value: datValue ? datValue.orden : '',
              size: 'col-md-6',
              placeholder: 'Ingrese el orden inicial de la columna',
              validations: {
                validators: [Validators.required, Validators.pattern(/^\d*$/), Validators.min(1)],
                messages: {
                  pattern: 'Caracteres incorrectos. Solo puede ingresar números enteros.',
                  min: 'Debe ingresar un número mayor a 0.'
                }
              }
            }),
          ]
        }),
        new Dropdown({
          key: 'cboTipoCampo',
          label: 'Tipo de campo',
          value: datValue ? datValue.tipo_campo : null,
          options: options,
          order: 4,
          validations: {
            validators: [Validators.required],
          }
        }),
        new Textbox({
          key: 'chkEstatico',
          label: 'Campo estatico',
          type: 'checkbox',
          value: datValue ? datValue.estatico : false,
          order: 5,
        }),
        
        new Custom({
          key: 'imagen',
          label: 'Imagen',
          order: 6,
          template: template,
          condictions: imageCondition
        }),
      ];

    } else {
      controls = [
        new Textbox({
          key: 'txtNombre',
          label: 'Título de la columna',
          value: datValue ? datValue.nombre : '',
          order: 1,
          placeholder: 'Ingrese el título de la columna',
          validations: {
            validators: [Validators.required],
          }
        }),
        new Container({
          class: 'form-row',
          order: 2,
          controls: [
            new Textbox({
              key: 'txtCelda',
              label: 'Celda Inicial:',
              value: datValue ? datValue.celda : '',
              size: 'col-md-6',
              placeholder: 'Ingrese la celda inicial para la columna',
              validations: {
                validators: [Validators.required, Validators.pattern(/^[A-Z ]*$/)],
                messages: {pattern: 'Caracteres incorrectos. Solo puede ingresar letras en mayuscula.'}
              }
            }),
            new Textbox({
              key: 'txtOrden',
              type: 'number',
              label: 'Orden inicial:',
              value: datValue ? datValue.orden : '',
              size: 'col-md-6',
              placeholder: 'Ingrese el orden inicial de la columna',
              validations: {
                validators: [Validators.required, Validators.pattern(/^\d*$/), Validators.min(1)],
                messages: {
                  pattern: 'Caracteres incorrectos. Solo puede ingresar números enteros.',
                  min: 'Debe ingresar un número mayor a 0.'
                }
              }
            }),
          ]
        }),
        new Dropdown({
          key: 'cboTipoCampo',
          label: 'Tipo de campo',
          value: datValue ? datValue.tipo_campo : null,
          options: options,
          order: 3,
          validations: {
            validators: [Validators.required],
          }
        }),
        new Textbox({
          key: 'chkEstatico',
          label: 'Campo estatico',
          type: 'checkbox',
          value: datValue ? datValue.estatico : false,
          order: 4,
        }),
      ];
    }

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/reports-structure/shared/reports-structure.form.service.ts